module.exports = __webpack_public_path__ + "images/no_data.a8fa35d7fd8a6a5c7c282bed59aad20c.png";